// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__38Xp_","alertIcon":"ConfirmModal_alertIcon__1U9Bx"};